<template>
  <RoutesForm :typeEndPoint="'schoolRoutesRoutesForm'" :dataParams="{}"/>
</template>
<script>
import RoutesForm from '@/components/modules/schoolroutes/routes/form'
export default {
  name: 'RoutesFormCreate',
  components: {
    RoutesForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/asignate/create.vue